/* =======================================================
   DRAG A KNOT — Sticky Header Scroll Trigger (Horizon)
   ======================================================= */
console.log('Drag A Knot header script loaded (v2)');

window.addEventListener('scroll', () => {
  const header =
    document.querySelector('header-component.header') ||
    document.querySelector('sticky-header') ||
    document.querySelector('header, .header');

  if (!header) {
    console.log('❌ Header element not found');
    return;
  }

  const isScrolled = window.scrollY > 10;
  header.classList.toggle('dak-scrolled', isScrolled);
  console.log('✅ Header element found, dak-scrolled:', isScrolled);
});
